import React, { useEffect, useState } from 'react';
import { FormGroup as BootstrapFormGroup, Label, Input } from 'reactstrap';
import PasswordToggle from '../../../../components/forms/formik/PasswordToggle';
import { Spinner } from 'reactstrap';
import { getUsersList } from '../../../../redux/users';
import { useSelector, useDispatch } from 'react-redux';
const GroupForm = ({
  label,
  name,
  type,
  placeholder,
  value,
  onChange,
  error,
  touched,
  user,
  userLoading
}) => {
  const userData = user ? user[name] : null;
  const isPassword = name === 'password';

  const [emailAlreadyExist, setEmailAlreadyExist] = useState(false);

  // get users list
  const dispatch = useDispatch();
  const usersList = useSelector((state) => state.users.usersList.users);
  useEffect(() => {
    dispatch(getUsersList());
  }, [dispatch]);

  const checkEmail = (email) => {
    const emails = usersList.map((user) => user.email);
    return emails.includes(email);
  };

  return (
    <BootstrapFormGroup>
      <Label for={name}>
        {label}{' '}
        {userLoading ? (
          <Spinner size="sm" color="primary" />
        ) : !user ? (
          <span className="text-danger">*</span>
        ) : isPassword ? (
          <>
            <span>( ****** )</span>
            <br />
            <small> leave it empty if you don't want to change it </small>
          </>
        ) : (
          <>
            ( {userData} )
            <br />
            <small> leave it empty if you don't want to change it </small>
          </>
        )}
      </Label>
      {isPassword ? (
        <PasswordToggle
          name={name}
          id={name}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
        />
      ) : (
        <Input
          type={type}
          name={name}
          id={name}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          required={name === 'expire_date' ? true : false}
          autoFocus={name === 'username' ? true : false}
          onBlur={(e) => {
            if (name === 'email') {
              if (checkEmail(e.target.value)) {
                setEmailAlreadyExist(true);
              }
            }
          }}
        />
      )}
      {error && touched && <p className="text-danger">{error}</p>}
      {emailAlreadyExist && <p className="text-danger">Email already exist</p>}
    </BootstrapFormGroup>
  );
};

export default GroupForm;
